/**
 * @description
 * Интерфейсы, которые используются во время валидации данных.
 */

export const getValidationResultInterface = (
  {
    title = '',
    subtitle = '',
    result = false,
  } = {},
): { title: string; result: boolean; subtitle: string } => ({
  // единый формат, который возвращает модуль валидации данных
  title, result, subtitle,
})
